import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';

export const logo = 'https://i.ibb.co/s9Qys2j/logo.png';

export const categories = [
  { name: 'New', icon: <HomeIcon />, },
  { name: 'Krety Facts', icon: <CodeIcon />, },
  { name: 'Facts', icon: <CodeIcon />, },
  { name: 'Animals Facts', icon: <CodeIcon />, },
  { name: 'Facts on Music', icon: <MusicNoteIcon /> },
  { name: ' Facts on Education', icon: <SchoolIcon />, },
  { name: 'Facts on Podcast', icon: <GraphicEqIcon />, },
  { name: 'Facts on Movie', icon: <OndemandVideoIcon />, },
  { name: 'Facts on Gaming', icon: <SportsEsportsIcon />, },
  { name: 'Facts on Live', icon: <LiveTvIcon />, },
  { name: 'Facts on Sport', icon: <FitnessCenterIcon />, },
  { name: 'Facts on Fashion', icon: <CheckroomIcon />, },
  { name: 'Facts on Beauty', icon: <FaceRetouchingNaturalIcon />, },
  { name: 'Facts on Comedy', icon: <TheaterComedyIcon />, },
  { name: 'Facts on Gym', icon: <FitnessCenterIcon />, },
  { name: 'Facts on Crypto', icon: <DeveloperModeIcon />, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'